/**
 * 支払手段の保存値 (サーバの services/pay/api/shared/domain/payment_methods.py と同じ)。#2571
 *
 * ポイント払い (YOKOSO ポイント #1800) は 'points'。種別は 現金・カード・ポイント・デジタル通貨 で、地域やイベントごとの
 * ポイントは種別に混ぜない。改名前の 'jpyc' (2026-09〜10 の demo のデータ) もポイントと読む — **暗号資産の JPYC とは
 * 関係ない**。保存された値と比べるときは必ず isPointsMethod (=== で比べると、古いポイント払いをカードとして扱う)。
 */
export const PAYMENT_METHOD_POINTS = 'points' as const

/**
 * Web3 の実験の経路 (opt-in。本番では使わない) で払ったときの、画面の状態 (`lastPaymentMethod`) の値。
 * **本物の JPYC トークン**のこと。改名前のポイントの値と同じ文字列だが、意味が違う (保存はしない)。
 */
export const WEB3_JPYC_PAYMENT = 'jpyc' as const

const LEGACY_PAYMENT_METHOD_POINTS = 'jpyc'

export function isPointsMethod(method: string | null | undefined): boolean {
  return method === PAYMENT_METHOD_POINTS || method === LEGACY_PAYMENT_METHOD_POINTS
}
